'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _underscore = require('../utils/underscore');

var _Dom = require('../utils/Dom');

var _passthroughProps = require('../utils/propTypes/passthroughProps');

var _passthroughProps2 = _interopRequireDefault(_passthroughProps);

var _ActiveElement = require('../core/ActiveElement');

var _ComponentWithUniqueIds = require('../mixins/ComponentWithUniqueIds');

var _ComponentWithUniqueIds2 = _interopRequireDefault(_ComponentWithUniqueIds);

var _Controllable = require('../decorators/Controllable');

var _Controllable2 = _interopRequireDefault(_Controllable);

var _reactUtils = require('react-utils');

var _icons = require('icons/icons');

var _icons2 = _interopRequireDefault(_icons);

var _KeyCodes = require('../constants/KeyCodes');

var _Selectors = require('../constants/Selectors');

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Functions = require('../core/Functions');

var _SyntheticEvent = require('../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _UIDropdownFooter = require('./UIDropdownFooter');

var _UIDropdownFooter2 = _interopRequireDefault(_UIDropdownFooter);

var _UIAbstractDropdown = require('./abstract/UIAbstractDropdown');

var _UIAbstractDropdown2 = _interopRequireDefault(_UIAbstractDropdown);

var _UIAbstractDropdownWithSearchbox = require('./abstract/UIAbstractDropdownWithSearchbox');

var _UIAbstractDropdownWithSearchbox2 = _interopRequireDefault(_UIAbstractDropdownWithSearchbox);

var _UITypeahead = require('../typeahead/UITypeahead');

var _UITypeahead2 = _interopRequireDefault(_UITypeahead);

var _UIGroupedTypeahead = require('../typeahead/UIGroupedTypeahead');

var _UIGroupedTypeahead2 = _interopRequireDefault(_UIGroupedTypeahead);

var _UIPopover = require('../tooltip/UIPopover');

var _UIPopover2 = _interopRequireDefault(_UIPopover);

var _PlacementConstants = require('../tooltip/PlacementConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var USE_CLASSES = {
  list: 'private-dropdown--list',
  unstyled: ''
};

var UIDropdown = _react2.default.createClass({
  displayName: 'UIDropdown',

  mixins: [_ComponentWithUniqueIds2.default, _reactAddonsPureRenderMixin2.default],

  propTypes: _extends({}, (0, _underscore.omit)(_UIAbstractDropdown2.default.propTypes, 'arrowColor'), {
    buttonClassName: _react.PropTypes.string,
    buttonText: _UIAbstractDropdown2.default.propTypes.buttonText,
    children: _UIAbstractDropdown2.default.propTypes.children,
    className: _react.PropTypes.string,
    closeOnMenuClick: _react.PropTypes.bool.isRequired,
    iconName: _UIAbstractDropdown2.default.propTypes.iconName,
    locked: _UIAbstractDropdown2.default.propTypes.locked,
    onOpenChange: _UIAbstractDropdown2.default.propTypes.onOpenChange,
    open: _UIAbstractDropdown2.default.propTypes.open,
    placement: _react.PropTypes.oneOf(_PlacementConstants.PLACEMENTS),
    popoverProps: (0, _passthroughProps2.default)(_UIPopover2.default),
    use: _react.PropTypes.oneOf(Object.keys(USE_CLASSES)).isRequired
  }),

  getDefaultProps: function getDefaultProps() {
    return _extends({}, _UIAbstractDropdown2.default.defaultProps, {
      buttonUse: 'tertiary-light',
      closeOnMenuClick: true,
      menuWidth: 'auto',
      pinToConstraint: ['left', 'right'],
      use: 'list'
    });
  },
  getInitialState: function getInitialState() {
    return {
      hasSearchbox: false
    };
  },
  componentDidMount: function componentDidMount() {
    this.checkForSearchbox();
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    // Only autofocus when `open` prop goes from false => true
    if (!this.props.open && nextProps.open) {
      this._enableAutofocus = true;
    }
  },
  componentDidUpdate: function componentDidUpdate() {
    this.checkForSearchbox();

    // Reposition the Tether, as the results list may have changed height.
    if (this._dropdownRef) {
      this._dropdownRef.reposition();
    }
  },
  checkForSearchbox: function checkForSearchbox() {
    // Check if we have a searchbox, as we may need to make the arrow color match.
    if (this._menuEl && document.body.contains(this._menuEl)) {
      var hasSearchbox = !!this._menuEl.querySelector('.private-typeahead:not(.hide-search)');
      if (this.state.hasSearchbox !== hasSearchbox) {
        this.setState({ hasSearchbox: hasSearchbox });
      }
    }
  },


  // Return the outermost <li> within the menu that contains `descendant`
  getClosestMenuItem: function getClosestMenuItem(descendant) {
    if (!descendant) {
      return null;
    }
    var parent = descendant.parentNode;
    var result = void 0;

    while (parent.id !== this.getMenuId()) {
      if (parent.tagName === 'LI') {
        result = parent;
      } else if (parent.tagName === 'HTML') {
        return null;
      }

      parent = parent.parentNode;
    }

    return result;
  },


  // Get the last <li> in the outermost group of list items within `menu`
  getLastMenuItem: function getLastMenuItem(menu) {
    if (!menu) {
      return null;
    }

    var lastMenuItem = menu.querySelector('li');
    if (!lastMenuItem) {
      return null;
    }

    while (lastMenuItem.nextSibling) {
      lastMenuItem = lastMenuItem.nextSibling;
    }
    return lastMenuItem;
  },
  getMenuId: function getMenuId() {
    return this.getUniqueId('dropdown');
  },
  containsFooter: function containsFooter(_ref) {
    var children = _ref.children;

    var childrenArray = _react.Children.toArray(children);
    for (var i = 0; i < childrenArray.length; i++) {
      var type = childrenArray[i].type;
      if (type === _UIDropdownFooter2.default) {
        return true;
      }
    }
    return false;
  },
  handleMenuClick: function handleMenuClick(evt) {
    var _props = this.props,
        closeOnMenuClick = _props.closeOnMenuClick,
        onOpenChange = _props.onOpenChange;

    if (closeOnMenuClick) {
      var target = evt.target;


      var iterableTarget = target;

      while (iterableTarget && !(0, _Dom.elementHasClass)(iterableTarget, 'private-dropdown')) {
        // Only close when clicking a `button` or `a` tag!
        if (['BUTTON', 'A'].indexOf(iterableTarget.nodeName) >= 0 && !iterableTarget.disabled) {
          onOpenChange((0, _SyntheticEvent2.default)(false));
          return;
        }

        iterableTarget = iterableTarget.parentElement;
      }
    }
  },
  handleOpenComplete: function handleOpenComplete() {
    var onOpenComplete = this.props.onOpenComplete;

    (0, _Functions.callIfPossible)(onOpenComplete);

    if (this._typeaheadRef && this._enableAutofocus) {
      (0, _Functions.callIfPossible)(this._typeaheadRef.focus);
      this._enableAutofocus = false;
    }
  },
  handleWindowKeyDown: function handleWindowKeyDown(evt) {
    var keyCode = evt.keyCode;
    var _props2 = this.props,
        onOpenChange = _props2.onOpenChange,
        open = _props2.open;

    if (!open) {
      return;
    }

    if (this.state.hasSearchbox) {
      if (keyCode === _KeyCodes.ENTER) {
        onOpenChange((0, _SyntheticEvent2.default)(false));
      }
      return;
    }

    if (keyCode === _KeyCodes.DOWN) {
      this.handleDownKeyPress(evt);
    } else if (keyCode === _KeyCodes.UP) {
      this.handleUpKeyPress(evt);
    }
  },


  // When DOWN is pressed, focus on first focusable element
  // within next menu item
  handleDownKeyPress: function handleDownKeyPress(e) {
    var menu = document.getElementById(this.getMenuId());
    var currentMenuItem = this.getClosestMenuItem((0, _ActiveElement.getActiveElement)());

    var focusTarget = void 0;

    if (currentMenuItem && currentMenuItem.nextSibling) {
      focusTarget = currentMenuItem.nextSibling.querySelector(_Selectors.FOCUSABLE);
    } else {
      focusTarget = menu.querySelector(_Selectors.FOCUSABLE);
    }

    if (focusTarget) {
      e.preventDefault();
      focusTarget.focus();
    }
  },


  // When UP is pressed, on first focusable element within previous menu item
  handleUpKeyPress: function handleUpKeyPress(e) {
    var menu = document.getElementById(this.getMenuId());
    var currentMenuItem = this.getClosestMenuItem((0, _ActiveElement.getActiveElement)());

    var focusTarget = void 0;

    if (currentMenuItem && currentMenuItem.previousSibling) {
      focusTarget = currentMenuItem.previousSibling.querySelector(_Selectors.FOCUSABLE);
    } else {
      var lastMenuItem = this.getLastMenuItem(menu);
      focusTarget = lastMenuItem ? lastMenuItem.querySelector(_Selectors.FOCUSABLE) : null;
    }

    if (focusTarget) {
      e.preventDefault();
      focusTarget.focus();
    }
  },
  handleSearchChange: function handleSearchChange() {
    // We reposition the Tether after the new search results flush to the DOM,
    // by way of componentDidUpdate().
    this.forceUpdate();
  },
  dropdownRefCallback: function dropdownRefCallback(ref) {
    this._dropdownRef = ref;
  },
  menuRefCallback: function menuRefCallback(ref) {
    this._menuEl = ref;
  },
  getIconName: function getIconName(_ref2) {
    var buttonText = _ref2.buttonText,
        iconName = _ref2.iconName;

    if (!buttonText && iconName === undefined) {
      return _icons2.default.SETTINGS;
    }
    return iconName;
  },
  getDropdownClassName: function getDropdownClassName(_ref3, _ref4) {
    var className = _ref3.className,
        dropdownClassName = _ref3.dropdownClassName,
        use = _ref3.use;
    var containsFooter = _ref4.containsFooter;

    return (0, _reactUtils.classNames)(className, dropdownClassName, USE_CLASSES[use], {
      'p-y-0': containsFooter
    });
  },
  render: function render() {
    var _this = this;

    var _props3 = this.props,
        autoPlacement = _props3.autoPlacement,
        buttonClassName = _props3.buttonClassName,
        buttonText = _props3.buttonText,
        buttonUse = _props3.buttonUse,
        children = _props3.children,
        className = _props3.className,
        __closeOnMenuClick = _props3.closeOnMenuClick,
        dropdownClassName = _props3.dropdownClassName,
        locked = _props3.locked,
        iconName = _props3.iconName,
        popoverProps = _props3.popoverProps,
        use = _props3.use,
        rest = _objectWithoutProperties(_props3, ['autoPlacement', 'buttonClassName', 'buttonText', 'buttonUse', 'children', 'className', 'closeOnMenuClick', 'dropdownClassName', 'locked', 'iconName', 'popoverProps', 'use']);

    var hasSearchbox = this.state.hasSearchbox;


    var containsFooter = this.containsFooter({ children: children });

    // For backward compatibility, both className and dropdownClassName add
    // classes to the dropdown. This redundancy will be removed in v2.
    var computedDropdownClassName = this.getDropdownClassName({ className: className, dropdownClassName: dropdownClassName, use: use }, { containsFooter: containsFooter });

    var mutatedChildren = void 0;
    if (hasSearchbox) {
      mutatedChildren = _react.Children.map(children, function (child) {
        if (child && (child.type === _UITypeahead2.default || child.type === _UIGroupedTypeahead2.default)) {
          return _react2.default.cloneElement(child, {
            onSearchChange: (0, _Functions.sequence)(child.props.onSearchChange, _this.handleSearchChange),
            ref: function ref(typeaheadRef) {
              _this._typeaheadRef = typeaheadRef;
            }
          });
        }
        return child;
      });
    }

    return _react2.default.createElement(
      _UIAbstractDropdownWithSearchbox2.default,
      _extends({}, rest, {
        autoPlacement: autoPlacement,
        buttonText: buttonText,
        buttonUse: buttonUse,
        className: buttonClassName,
        dropdownClassName: computedDropdownClassName,
        hasSearchbox: this.state.hasSearchbox,
        iconName: this.getIconName({ buttonText: buttonText, iconName: iconName }),
        locked: locked,
        onOpenComplete: this.handleOpenComplete,
        onWindowKeyDown: this.handleWindowKeyDown,
        popoverProps: popoverProps,
        ref: this.dropdownRefCallback
      }),
      _react2.default.createElement(
        'div',
        {
          id: this.getMenuId(),
          onClick: this.handleMenuClick,
          ref: this.menuRefCallback
        },
        mutatedChildren || children
      )
    );
  }
});

exports.default = (0, _Controllable2.default)(UIDropdown, ['open']);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1179/js/dropdown/UIDropdown.js
// module id = 299
// module chunks = 0